import Service from './Service'
import { USER, SELLER } from './apiUrls'

export default class GroupService extends Service {
  get (managerId, query) {
    return this.axios.get(`${USER}/${managerId}/${SELLER}`, {params: query})
  }
  delete (managerId, sellerId, query) {
    return this.axios.delete(`${USER}/${managerId}/${SELLER}/${sellerId}`)
  }
  post (managerId, data) {
    return this.axios.post(`${USER}/${managerId}/${SELLER}`, data)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/GroupService.js